module.exports = "nav li.active {\n  background-color: #C41230;\n  color: #fff;\n  border-radius: 0px 50px 50px 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/sidenav/sidenav-menu/sidenav-menu.component.scss
// module id = 907
// module chunks = 10